import {Injectable} from '@angular/core';
import { Title } from '@angular/platform-browser';
import {Asset, AssetInfo} from '../domain/item';
import {AuctionEvent} from '../domain/auction-event';

@Injectable({
  providedIn: 'root'
})
export class ItemSummaryPageService{

  private asset: Asset;
  private assetInfo: AssetInfo;
  private auctionEvent: AuctionEvent;

  constructor(private titleService: Title) {}

  private generateTitlePage(): void {
    let titlePage = '';
    if ( this.asset ){
      if ( this.asset.isRBAsset() ){
        const saleNumber: string = ( this.auctionEvent ) ? ' - ' + this.auctionEvent.saleNumber : '';
        const customDescription: string = ' - ' + this.asset.customDescrTxt;
        const ownerCode: string = ( this.asset.ownerCode ) ? this.asset.ownerCode : '';
        const scheduleA: string = ( ( ownerCode && this.asset.scheduleA) ? '/' + this.asset.scheduleA + ' ' : ( (this.asset.scheduleA) ? this.asset.scheduleA : '' ) ).toString();
        const assetId: number = this.asset.assetId;
        titlePage = ( (ownerCode && scheduleA ) ?  ownerCode + scheduleA : assetId ) + customDescription + saleNumber;
      } else {
        if ( this.assetInfo ){
          const assetId: number = this.assetInfo.assetId;
          const equipId = this.assetInfo.equipId;
          const itemId = equipId ? equipId : assetId;
          const customDescription: string = this.assetInfo.customDescrTxt;
          titlePage = itemId + ' - ' + customDescription;
        }
      }
    }
    this.titleService.setTitle(titlePage);
  }

  public loadAssetInformation(loadedAsset: Asset): void {
    if ( loadedAsset ) {
      this.asset = loadedAsset;
      this.generateTitlePage();
    }
  }

  public loadAssetInfoInformation(loadedAssetInfo: AssetInfo){
    if ( loadedAssetInfo ){
      this.assetInfo = loadedAssetInfo;
      this.generateTitlePage();
    }
  }

  public loadAuctionEventInformation(loadedAuctionEvent: AuctionEvent){
    if ( loadedAuctionEvent ){
      this.auctionEvent = loadedAuctionEvent;
      this.generateTitlePage();
    }
  }

}
